import React from "react";
import { Link } from "react-router-dom";
import { BsArrowRightShort } from "react-icons/bs";
import { useNavContext } from "../context-api/nav-context";

const Hero = ({ data }) => {
  const { heroTitle, heroImg, altText } = data[0];
  const { closeNavbarMenu } = useNavContext();
  return (
    <section className="hero" onMouseOver={closeNavbarMenu}>
      <div className="hero-text wrapper">
        <div className="hero-heading">
          <h1 className="hero-title">{heroTitle}</h1>
        </div>
        <div className="hero-btns">
          <Link to="/question-one" className="btn-hero btn-quote">
            Instant Boiler Quote <BsArrowRightShort class="btn-arrow" />
          </Link>
        </div>
        <div className="hero-badges">
          <img
            src="https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,q_100,w_300/v1642184261/AquaHeat/HeroImages/trustpilot_vqnxao.webp"
            alt="Trust Pilot rating"
          />
          <img
            src="https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,q_100,w_400/v1642184460/AquaHeat/HeroImages/which_rhfac7.webp"
            alt="Which trusted traders"
          />
          <img
            src="https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,q_80,w_300/v1642184491/AquaHeat/HeroImages/google1_wge6l3.webp"
            alt="Google Reviews logo"
          />
        </div>
      </div>
      <div className="hero-image">
        <img
          src="https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,q_80,w_600/v1642183654/AquaHeat/HeroImages/hero-bg_ejkrpz.webp"
          alt="aquaheat brand colours"
        />
      </div>
      <div className="hero-boiler_boiler-page">
        <img src={heroImg} alt={altText} />
      </div>
    </section>
  );
};

export default Hero;
